import styled from 'styled-components';
import { IFrame } from './interface';

const templateAreaForGlobalActive = `
  'boletosLiquided faresReceived'
  'income lastTwelveMonths'
  'table table '
`;

const templateAreaForGlobalInactive = `
  'faresReceived faresReceived faresPassedOn faresPassedOn income income'
  'boletosLiquided boletosLiquided boletosLiquided lastTwelveMonths lastTwelveMonths lastTwelveMonths '
`;

const base = styled.div<IFrame>`
  display: ${(props) => (props.isActive === true ? 'grid' : 'none')};
  grid-template-columns: ${(props) =>
    props.globalIsActive ? 'repeat(2, 1fr)' : 'repeat(6, 1fr)'};
  grid-template-rows: ${(props) =>
    props.globalIsActive ? 'repeat(3, 1fr)' : 'repeat(2, 1fr)'};
  grid-template-areas: ${(props) =>
    props.globalIsActive
      ? templateAreaForGlobalActive
      : templateAreaForGlobalInactive};
  column-gap: 1rem;
  row-gap: 1rem;
  width: 100%;
  min-height: 100%;
  margin-top: 0.5rem;

  @media (min-width: ${(props) => props.theme.mediaQuery.desktop}) {
    grid-template-columns: ${(props) =>
      props.globalIsActive ? 'repeat(2, 1fr)' : 'repeat(6, 1fr)'};
    grid-template-rows: ${(props) =>
      props.globalIsActive ? 'repeat(3, 1fr)' : 'repeat(2, 1fr)'};
  }
`;

const Frame = {
  Base: base,
};

export default Frame;
